/* Shared timber profiles 1.0.0 — authoritative material generator for BOTH 3D views.
 * Only ThermoAspen is specified. Future species register via registerSpecies,
 * then project.cladding.wall/ceiling.speciesId and project.cladding.bench.speciesId.
 * Renderers own texture disposal; this module neither saves project data nor
 * selects alternative species automatically.
 */
(function(W,D){'use strict';
if(W.ThermoAspenTimberMaterialsV1&&W.ThermoAspenTimberMaterialsV1.version==='1.0.0')return;
var Z=Math,profiles=Object.create(null);
function PR(n){var x=Z.sin(n*12.9898+78.233)*43758.5453;return x-Z.floor(x)}
function X(n,a,b){return Z.max(a,Z.min(b,n))}
function N(x,d){x=Number(x);return isFinite(x)?x:d}
function WCOL(T,hex,seed,v){var c=new T.Color(hex);c.offsetHSL((PR(seed*5.17+13)-.5)*.05*v,(PR(seed*7.31+29)-.5)*.16*v,(PR(seed*11.03+41)-.5)*.30*v);return '#'+c.getHexString()}
function WGC(ctx,vr,c0,cw,run,seed,p,figureCut){var j,k,q,amp,lw,a,ph,n,cy,half,cx,mx,r,sg,u,shape;ctx.save();ctx.lineCap='round';for(j=0;j<3;j++){q=c0+cw*(.15+.70*PR(seed*4.7+j*3.9));amp=cw*(.010+.025*PR(seed*6.1+j));lw=Z.max(2,cw*(.045+.075*PR(seed*8.3+j)));a=.012+.025*p+.010*PR(seed*9.7+j);ctx.strokeStyle=j%2?'rgba(255,235,212,'+a+')':'rgba(83,57,42,'+a+')';ctx.lineWidth=lw;ctx.beginPath();for(k=0;k<=run;k+=12){var c=q+Z.sin(k*.007+j)*amp+Z.sin(k*.0022+j*.7)*amp*.65;if(vr){if(k===0)ctx.moveTo(c,k);else ctx.lineTo(c,k)}else{if(k===0)ctx.moveTo(k,c);else ctx.lineTo(k,c)}}ctx.stroke()}n=10+Z.round(5*p);for(j=0;j<n;j++){q=c0+cw*(.065+.87*(j+.30*PR(seed*11+j))/n);amp=cw*(.004+.012*PR(seed*13+j));a=.024+.045*p+.018*PR(seed*17+j);ph=PR(seed*19+j)*6.283;ctx.strokeStyle=j%5?'rgba(86,59,44,'+a+')':'rgba(248,226,203,'+Z.max(.014,a*.55)+')';ctx.lineWidth=.65+PR(seed*21+j)*.55;ctx.beginPath();for(k=0;k<=run;k+=10){var c2=q+Z.sin(k*.008+ph)*amp+Z.sin(k*.0029+ph*.4)*amp*.7;if(vr){if(k===0)ctx.moveTo(c2,k);else ctx.lineTo(c2,k)}else{if(k===0)ctx.moveTo(k,c2);else ctx.lineTo(k,c2)}}ctx.stroke()}if(PR(seed*37+5)>figureCut){cy=run*(.22+.56*PR(seed*47));half=run*(.16+.18*PR(seed*53));cx=c0+cw*(.38+.24*PR(seed*59));mx=cw*(.15+.10*PR(seed*61));r=3+Z.round(2*PR(seed*67));for(j=0;j<r;j++){var ra=mx*(.35+.65*(j+1)/r),al=.032+.030*p+.014*PR(seed*71+j);for(sg=-1;sg<=1;sg+=2){ctx.strokeStyle='rgba(91,61,45,'+al+')';ctx.lineWidth=.7;ctx.beginPath();var begun=false;for(k=Z.max(0,cy-half);k<=Z.min(run,cy+half);k+=7){u=Z.abs((k-cy)/half);if(u>1)continue;shape=Z.pow(Z.max(0,1-Z.pow(u,1.14)),.56);var cc=cx+sg*ra*shape;if(vr){if(!begun){ctx.moveTo(cc,k);begun=true}else ctx.lineTo(cc,k)}else{if(!begun){ctx.moveTo(k,cc);begun=true}else ctx.lineTo(k,cc)}}ctx.stroke()}}}ctx.restore()}
function deepFreeze(o){Object.keys(o).forEach(function(k){if(o[k]&&typeof o[k]==='object')deepFreeze(o[k]);});return Object.freeze(o)}
function registerSpecies(def){
  if(!def||!/^[a-z0-9][a-z0-9_-]*$/.test(def.id||'')||!def.label)throw Error('A species must have an id and label');
  if(profiles[def.id])throw Error('Species already registered: '+def.id);
  ['wall','ceiling','bench'].forEach(function(role){
    var p=def.roles&&def.roles[role],t=p&&p.texture;
    if(!p||!t||!Number.isInteger(t.baseColor)||!Number.isInteger(p.tint))throw Error('Missing '+role+' material profile');
    ['grainPresence','variation','figureCut','roughness'].forEach(function(k){
      var n=k==='roughness'?p[k]:t[k];if(typeof n!=='number'||!isFinite(n)||n<0||n>1)throw Error('Invalid '+role+'.'+k);
    });
  });
  profiles[def.id]=deepFreeze(JSON.parse(JSON.stringify(def)));
  return def.id;
}
// These are the original Interior 3D Preview wood settings, unaltered.
registerSpecies({id:'thermoaspen',label:'ThermoAspen',roles:{
  wall:{tint:0xe8d2c0,roughness:.90,texture:{baseColor:0xbe9d80,grainPresence:.28,variation:.20,figureCut:.58}},
  ceiling:{tint:0xe8d2c0,roughness:.88,texture:{baseColor:0xbe9d80,grainPresence:.28,variation:.20,figureCut:.58}},
  bench:{tint:0xe8d2c0,roughness:.86,texture:{baseColor:0xaf886c,grainPresence:.44,variation:.15,figureCut:.48}}
}});
function profile(id){return profiles[id]||null}
function resolveSpecies(scene,role){
  var c=scene&&scene.cladding||{},m=scene&&scene.materials||{};
  var choice=role==='bench'?(c.bench||m.bench||scene&&scene.benchMaterials):(c[role]||m[role]);
  var id=choice&&(choice.speciesId||choice.timberSpecies||choice.species);
  return typeof id==='string'&&id?id:'thermoaspen';
}
function appearance(speciesId,role){
  var p=profile(speciesId);if(!p||!p.roles[role])throw Error('Unsupported timber species: '+speciesId);
  return p.roles[role];
}
function params(speciesId,role,override){
  var p=appearance(speciesId,role),t=p.texture;
  // The old 3D viewer exposes tunable ThermoAspen grain levels. Carry them
  // across only for that species, not to unrelated future timber profiles.
  if(speciesId==='thermoaspen'&&override)t=Object.assign({},t,override);
  return t;
}
function finishTexture(T,R,c,repeat,boardCount){
  var tex=new T.CanvasTexture(c);tex.wrapS=tex.wrapT=repeat?T.RepeatWrapping:T.ClampToEdgeWrapping;
  tex.colorSpace=T.SRGBColorSpace;
  if(R&&R.capabilities&&R.capabilities.getMaxAnisotropy)tex.anisotropy=Z.min(8,R.capabilities.getMaxAnisotropy());
  if(boardCount)tex.userData.boardCount=boardCount;
  return tex;
}
function createCladdingTexture(T,R,opt){
  opt=opt||{};var id=opt.speciesId||'thermoaspen',t=params(id,opt.role||'wall',opt.override);
  var c=D.createElement('canvas'),ctx=c.getContext('2d'),vr=opt.direction!=='horizontal';
  var boards=8,step,pos,joint,p=X(t.grainPresence,0,1),v=X(t.variation,0,1);
  c.width=c.height=512;step=512/boards;
  for(var i=0;i<boards;i++){
    pos=i*step;ctx.fillStyle=WCOL(T,t.baseColor,i+17,v);
    if(vr)ctx.fillRect(pos,0,step+1,c.height);else ctx.fillRect(0,pos,c.width,step+1);
    WGC(ctx,vr,pos,step,512,i+31,p,t.figureCut);
    joint=Z.max(1.5,step*.026);ctx.fillStyle='rgba(63,40,28,.74)';
    if(vr)ctx.fillRect(pos,0,joint,c.height);else ctx.fillRect(0,pos,c.width,joint);
    ctx.fillStyle='rgba(255,238,217,.14)';
    if(vr)ctx.fillRect(pos+joint,0,1,c.height);else ctx.fillRect(0,pos+joint,c.width,1);
  }
  return finishTexture(T,R,c,true,boards);
}
function createMemberTexture(T,R,opt){
  opt=opt||{};var id=opt.speciesId||'thermoaspen',t=params(id,opt.role||'bench',opt.override);
  var seed=N(opt.seed,200),vr=opt.direction==='vertical';
  var c=D.createElement('canvas'),ctx=c.getContext('2d'),cw=vr?160:512,ch=vr?512:160;
  c.width=cw;c.height=ch;ctx.fillStyle=WCOL(T,t.baseColor,seed,t.variation);ctx.fillRect(0,0,cw,ch);
  WGC(ctx,vr,0,vr?cw:ch,vr?ch:cw,seed,t.grainPresence,t.figureCut);
  return finishTexture(T,R,c,false,0);
}
W.ThermoAspenTimberMaterialsV1=Object.freeze({version:'1.0.0',registerSpecies:registerSpecies,
  getSpecies:profile,resolveSpecies:resolveSpecies,getAppearance:appearance,
  createCladdingTexture:createCladdingTexture,createMemberTexture:createMemberTexture});
})(window,document);
